import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  handleGeneratePermitNumber,
  handleRealEstatePreset,
} from "../../../store/actions/uiActions/myPermitsActions";
import { LoadingButton } from "@mui/lab";
import { FunFact } from "../FunFact";
import { formikRef } from "../../../store/formikStore/formikStore";

const ConfirmSelectedAddress = ({ confirmOpen, setConfirmOpen, msg, step }) => {
  const dispatch = useDispatch();
  const [displayFunFacts, setDisplayFunFacts] = useState(false);
  const formik = formikRef.current;

  const { presetLoading } = useSelector(
    (state) => state.myPermitsComponent.realEstate
  );

  const { cityPermitLoading } = useSelector(
    (state) => state.myPermitsComponent.citySite
  );

  const fetchRealEstatePreset = async () => {
    try {
      await dispatch(handleRealEstatePreset(formik?.values));
    } catch (e) {
    } finally {
      setConfirmOpen(false);
    }
  };

  const fetchGeneratePermitNumber = async () => {
    try {
      setDisplayFunFacts(true);
      await dispatch(handleGeneratePermitNumber(formik?.values));
    } catch (e) {
    } finally {
      setDisplayFunFacts(false);
      setConfirmOpen(false);
    }
  };

  return (
    <Dialog
      open={confirmOpen}
      onClose={() => {
        if (step === 1) {
          if (presetLoading) {
            return;
          } else {
            setConfirmOpen(false);
          }
        } else if (step === 2) {
          if (cityPermitLoading) {
            return;
          } else {
            setConfirmOpen(false);
          }
        }
      }}
      maxWidth={displayFunFacts ? "md" : "xs"}
      fullWidth
    >
      <DialogTitle>
        {displayFunFacts
          ? "Creating Notice of Commencement..."
          : "Confirm Action"}
      </DialogTitle>
      <DialogContent>
        {displayFunFacts ? (
          <FunFact />
        ) : (
          <Typography variant="body2">{msg}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={step === 1 ? presetLoading : cityPermitLoading}
          onClick={() => setConfirmOpen(false)}
        >
          Cancel
        </Button>
        <LoadingButton
          loading={step === 1 ? presetLoading : cityPermitLoading}
          onClick={() => {
            if (step === 1) {
              fetchRealEstatePreset();
            } else if (step === 2) {
              fetchGeneratePermitNumber();
            }
          }}
          variant="contained"
          color="primary"
        >
          Confirm
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ConfirmSelectedAddress);
